import { BrowserLib } from '@repo/browserlib';

// Create handler
const handler = new BrowserLib();

// For parallel structure with desktop handler
export async function getHandler(): Promise<BrowserLib> {
	return handler;
}

// For backward compatibility
export { handler };
